import { Col, Layout, Row, Avatar, Typography, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import { connect, useSelector } from "react-redux";
import Header from "../Authorized/Header";
import Pagination from "./Pagination";
import { getAllNotifications } from "../Redux/User/reducer";
import { Helmet } from "react-helmet";

const AllNotifications = (props) => {
  const { allNotifications, totalNotifications } = useSelector(
    (state) => state.userStore
  );
  const { fetchNotificaitons } = props;
  const formattedDate = (date) => moment.utc(date).from(moment());
  const actualDate = (date) => moment.utc(date).local().format("DD/MM/YYYY LT");
  const getPage = async (page) => {
    await fetchNotificaitons(page - 1);
  };
  return (
    <Layout>
      <Helmet title="Notificaitons | Unicon" />
      <Header></Header>
      <Layout.Content>
        <Col xl={{ span: 20 }} style={{ margin: "auto" }}>
          <Row>
            <Typography.Title level={5}>Your Notifications</Typography.Title>
          </Row>
          {allNotifications.map((notification) => (
            <Col
              key={notification.id}
              xl={{ span: 16 }}
              style={{
                padding: "2vh",
                background: "#ffffff",
                border: "1px solid #f4f4f4",
                margin: "2vh",
                marginRight: "auto",
                borderRadius: "4px",
              }}
            >
              <Row>
                <Col xl={{ span: 20 }}>
                  <Row align="middle" justify="space-between">
                    <Col xl={{ span: 2 }}>
                      <Avatar
                        size="large"
                        style={{ backgroundColor: "#90caf9" }}
                      >
                        S
                      </Avatar>
                    </Col>
                    <Col xl={{ span: 21 }}>
                      <Typography.Text>{notification.text}</Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Tooltip title={actualDate(notification.createdDate)}>
                    {formattedDate(notification.createdDate)}
                  </Tooltip>
                </Col>
              </Row>
            </Col>
          ))}
          <Pagination totalJobs={totalNotifications} getPage={getPage} />
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNotificaitons: (page) => dispatch(getAllNotifications(page)),
  };
};

export default connect(null, mapDispatchToProps)(AllNotifications);
